import { defineComponent, onMounted, onUnmounted } from 'vue';
import ErrorModalCode from '@/presentation/components/error-modal/error-modal.code';

export default defineComponent({
	setup: () => {
		const code = new ErrorModalCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			modalContent: code.modalContent,
			errorIsRelatedToRetrieveDashboards: code.errorIsRelatedToRetrieveDashboards,
			errorIsRelatedToRetrieveJWT: code.errorIsRelatedToRetrieveJWT,
			errorIsRelatedToRetrieveJWTInstanceId: code.errorIsRelatedToRetrieveJWTInstanceId
		};
	}
});
